
export const PROCESS_INSTANCE = 'processInstanceLoaded'

export const SALES_ORDER = 'findSalesOrderSuccess'

export const CUSTOMER = 'findCustomerSuccess'

export const TREATMENT_PLAN = 'treatmentPlanLoaded'

export const TREATMENT_QUOTATION = 'treatmentQuotation'

export const QUOTATION_CUSTOMER_LOADED = 'quoatationCustomerLoaded'

export const INVOICE_CORRECTION = 'findInvoiceById'

// prospect process

export const PROSPECT_LOADED = 'findProspectSuccess'

// rescan appointment

export const RESCAN_APPOINTMENT_TOGGLE_IMAGE_VIEW = 'toggleImageView'



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/process-action.js